import axios from "axios";
import Config from "../../../config";

const v2_actionRemoveParticipant = (chatId, waId) => axios({
    method: "delete",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/participants/${waId}`
});

export default v2_actionRemoveParticipant;
